import { createFactory } from 'react';

/**
 * mapProps c возможностью запулить создание селектора
 * использует фунцию которая которая создаст инстанс селектора
 * и вернет функию маппинга свойств, в которой может использоватся этот селектор
 */

// FAIL не работает как должно

/** нужно примерно так
  withHandlers(() => {
    const selectData = createSelectData();
    return ({
      selectData: () => selectData,
    });
  }),
  mapProps((props) => {
    const { selectData } = props;
    return ({
      data: selectData(props),
      ...props,
    });
  }),
*/

const mapPropsCreate = propsMapperMaker => (BaseComponent) => {
  const factory = createFactory(BaseComponent);
  const MapPropsCreate = (props) => {
    const propsMapper = propsMapperMaker();
    return factory(propsMapper(props));
  };
  // TODO setDisplayName ?
  return MapPropsCreate;
};

export default mapPropsCreate;
